import * as R from "ramda";
import PropTypes from "prop-types";

export const columnShape = {
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  options: PropTypes.shape({
    show: PropTypes.bool, // default to true
    sort: PropTypes.bool, // default to true
    filter: PropTypes.bool, // default to true
    visible: PropTypes.bool, // default to true
    weigth: PropTypes.number, // default 1, order filter asc
    cellRenderer: PropTypes.func,
    filterRenderer: PropTypes.func,
    headerRenderer: PropTypes.func,
    expandedColumn: PropTypes.bool,
    emptyFilteredElement: PropTypes.node,
    cellClass: PropTypes.string,
    headerClass: PropTypes.string
  })
};
columnShape.columns = PropTypes.arrayOf(PropTypes.shape(columnShape));
const compareFilterWeigth = (a, b) => {
  let sortResult = 0;
  const optionsA = a.options;
  const optionsB = b.options;
  if (optionsA.weigth && optionsB.weigth) {
    sortResult = optionsA.weigth - optionsB.weigth;
  }
  return sortResult;
};

export const parseColumns = (columns, columnFilters) => {
  return columns.map(column => {
    const parsedColumn = {
      accessor: column.name,
      Header: column.label,
      show: true,
      id: column.name
    };
    if (column.options) {
      const {
        cellRenderer,
        headerRenderer,
        show,
        sort,
        cellClass,
        headerClass,
        expandedColumn,
        type,
      } = column.options;
      parsedColumn.show =
        show === undefined ||
        show === null ||
        (show && columnFilters.some(x => x.key === column.name));
      if (cellRenderer) {
        parsedColumn.Cell = cellRenderer;
      }
      if (headerRenderer) {
        parsedColumn.Header = headerRenderer;
      }
      if (type) {
        parsedColumn.type = type;
      }
      parsedColumn.disableSortBy = sort === false;
      parsedColumn.cellClass = cellClass || "";
      parsedColumn.headerClass = headerClass || "";
      parsedColumn.isExpandableColumnInfo = Boolean(expandedColumn);
    }
    if (column.columns) parsedColumn.columns = parseColumns(column.columns);
    return parsedColumn;
  });
};

export const parseFilters = (columns, data, selectedFilters) => {
  const filtrableColumns = columns
    .filter(x => x.options && x.options.filter)
    .sort(compareFilterWeigth)
    .map(x => {
      return {
        filterRenderer: x.options ? x.options.filterRenderer : value => value,
        type: x.options.type ? x.options.type : "string",
        label: x.label,
        key: x.name
      };
    });
  return filtrableColumns.map(x => {
    const values = data
      .filter(item => {
        let isValid = true;
        selectedFilters.forEach(el => {
          if (el.type && el.type === "date") {
            isValid = true;
            /*  isValid &&
              moment(item[el.key], tableDateFormat).isSameOrAfter(
                moment(el.value.startDate, dateFormat)
              ) &&
              moment(item[el.key], tableDateFormat).isSameOrBefore(
                moment(el.value.endDate, dateFormat)
              ); */
          } else {
            isValid = isValid && (el.value === "all" || item[el.key] === el.value);
          }
        });
        return isValid;
      })
      .map(row => row[x.key])
      .filter(y => y != null);
    const options = R.uniq(values);
    return {
      ...x,
      options: options || []
    };
  });
};

export const parseVisibleColumnFilters = (columns, activeFilter) => {
  return columns
    .filter(x => x.options && x.options.show)
    .map(x => {
      return {
        label: x.label,
        key: x.name,
        isActive: activeFilter.some(y => y.key === x.name)
      };
    });
};

export const initialColumnFilter = columns => {
  return columns
    .filter(x => x.options && x.options.show)
    .map(x => {
      return {
        label: x.label,
        key: x.name,
        isActive: true
      };
    });
};

export default { parseColumns, parseFilters };
